<template>
  <div class="page-content d-flex flex-column">
    <Titlebar :incrustation="'fa-pie-chart'">
      <h1>{{ $t('home.title') }}</h1>
    </Titlebar>
    <div
        v-if="displayWarning"
        class="alert alert-warning m-3 flex-1 d-flex flex-row justify-content-between align-items-center"
    >
      <span v-html="$t('general_warning')"></span>
      <button type="button" class="close" data-dismiss="alert" :aria-label="$t('global.close')" @click="dismissWarning">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
        id="home-container"
        class="flex-1"
        style="margin: 0 -16px; width: calc(100% + 16px + 16px);"
    >
      <grid-layout
          :layout="layout"
          :col-num="3"
          :maxRows="1"
          :row-height="rowHeight"
          :is-draggable="false"
          :is-resizable="false"
          :vertical-compact="true"
          :margin="[16, 0]"
          :use-css-transforms="false"
      >
        <grid-item
            v-for="(item, index) in layout"
            :key="item.i"
            :x="index"
            :y="item.y"
            :w="1"
            :h="1"
            :i="item.i"
            :dragIgnoreFrom="'.grid-item-inner,.zmdi'"
            :class="item.fullscreenClass"
        >
          <UiCard style="padding: 0!important; overflow: hidden; height: 100%;">
            <h3 class="vue-draggable-handle bg-gray-200 text-gray-700">
              {{ item.widgetOptions.title }}
              <i class="fa fa-info-circle text-dark warning-beepiz-remote-monitoring show" style="right:30px; font-size: 1.5em"></i>
              <div v-if="item.widgetOptions.id == 22" class="tooltip top" style="width: 250px; right:40px; top:50px">
                <h5>{{ $t('home.widgets.list.sessionInfoTitle') }}</h5>
                {{ $t('home.widgets.list.sessionInfoBody') }}
              </div>
              <div v-if="item.widgetOptions.id == 23" class="tooltip top" style="width: 250px; right:40px; top:50px">
                <h5>{{ $t('home.widgets.list.mapInfoTitle') }}</h5>
                {{ $t('home.widgets.list.mapInfoBody') }}
              </div>
              <div v-if="item.widgetOptions.id == 24" class="tooltip top" style="width: 250px; right:40px; top:50px">
                <h5>{{ $t('home.widgets.list.eventInfoTitle') }}</h5>
                {{ $t('home.widgets.list.eventInfoBody') }}
              </div>
              <i
                  class="zmdi"
                  @click.stop="handleFullscreen(item)"
                  :class="item.fullscreenClass ? 'zmdi-fullscreen-exit' : 'zmdi-fullscreen'"
              ></i>
            </h3>
            <div class="grid-item-inner text-sm">
              <component :ref="getWidgetId(item)" v-bind:is="item.widget" :options="item.widgetOptions"
                         :source="item.source" :resize="resizeMap"></component>
            </div>
          </UiCard>
        </grid-item>
      </grid-layout>
    </div>
  </div>
</template>

<script>
import includes from 'lodash/includes';
import axios from 'axios';
import API from '@/services/API.js'
import Utils from '@/services/utils.js'
import Titlebar from '@/components/ui/Titlebar'
import Toolbar from '@/components/ui/Toolbar'
import Btn from '@/components/ui/Button'
import UiCard from '@/components/ui/Card'
import Vue from 'vue'
import {GridLayout, GridItem} from 'vue-grid-layout'
import moment from 'moment';
import 'moment-timezone';

// Widgets
import Map from '@/components/dashboard/widgets/Map';
import List from '@/components/dashboard/widgets/List';

// Sources
import Source from '@/components/dashboard/sources/Source.js';
import {useDvFlagAccess} from "../services/featureFlag";

export default {
  name: 'home',
  components: {
    Titlebar,
    Toolbar,
    Btn,
    UiCard,
    GridLayout,
    GridItem,
  },
  data: () => ({
    isSNCF:false,
    layout: [],
    rowHeight: 0,
    sourcesUrls: [],
    sources: {},
    refresh: true,
    resizeMap: false,
    nbRows: 1,
    isClosedWarning: false
  }),

  mounted(){
    window.addEventListener('resize', this.resizeListener, true);

    this.rowHeight = document.getElementById('home-container').offsetHeight;
    if (!useDvFlagAccess("beepiz-dashboard-live-session-can:read")) {
      this.$router.push({ name: 'AccessDenied', params: { slug: 'dashboard'} })
    }
    this.loadData();
  },

  computed: {
    displayWarning: function () {
      return !this.isClosedWarning && moment().isBefore(Utils.momentLocalised("2023-11-28 14:00:00"));
    }
  },

  methods: {
    dismissWarning: function() {
      this.isClosedWarning = true;
    },
    resizeListener: function(){
      this.rowHeight = document.getElementById('home-container').offsetHeight;

      this.resizeMap = !this.resizeMap
    },
    handleFullscreen: function (item) {
      if (item.fullscreenClass == '') {
        item.fullscreenClass = 'vue-grid-item-fullscreen';
      }
      else {
        item.fullscreenClass = '';
      }

      this.resizeMap = !this.resizeMap;


    },
    getWidgetId: function(item){
      return item.type+item.id;
    },
    gridItemSizesClasses: function (item) {
      return 'grid-item__width-' + item.w + ' grid-item__height-' + item.h;
    },
    handleAddWidget: function () {

    },
    loadData: function () {

      axios.get(
          API.managementBaseURL + API.endpoints.dashboard.messageSite
      )
          .then(response => {
            if (window.V.$localStorage.get("bpz_lang") === 'fr')
              window.Vfc.$refs.messages.sendMessage(response.data.data.type_message, response.data.data.message);
            else
              window.Vfc.$refs.messages.sendMessage(response.data.data.type_message, response.data.data.message_en);
          })

      var params = {}

      axios.get(API.endpoints.dashboard.widgets + API.constructQueryParams(params))
          .then(response => {

            var widgets = response.data;

            var widgetDef = null;
            for (var wKey in widgets) {
              widgetDef = widgets[wKey];


              var widgetLayout = {};

              widgetLayout.widgetOptions = {
                title: widgetDef.widget.name,
                id: widgetDef.widget.id
              };

              widgetLayout.x = parseInt(widgetDef.widget.position.col);
              widgetLayout.y = parseInt(widgetDef.widget.position.row);
              widgetLayout.w = (this.isSNCF) ? 3 : 1;
              widgetLayout.h = 1;
              widgetLayout.i = wKey;
              switch (widgetDef.widget.type) {
                case 'list':
                  widgetLayout.widget = List;
                  break;
                case 'map':
                  widgetLayout.widget = Map;
                  break;
                default:
                  continue;
                  break;
              }

              Vue.util.defineReactive(widgetLayout, 'fullscreenClass', '');

              if (widgetDef.data.source.url != null && !includes(this.sourcesUrls, widgetDef.data.source.url)) {
                this.sourcesUrls.push(widgetDef.data.source.url);
                var source = new Source(widgetDef.data.source.url, widgetDef.data.source.refresh, this.refresh);
                this.sources[widgetDef.data.source.url] = source;
                widgetLayout.source = source;
              } else {
                widgetLayout.source = this.sources[widgetDef.data.source.url];
              }

              if (this.isSNCF) {
                if (widgetLayout.source.name === 'Datis') continue;
              }

              this.layout.push(widgetLayout);
            }

            window.Vfc.$refs.loading.hide();
          })
          .catch(error => {
            if (403 === error?.response?.status) {
              window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.e403') + ' ' + error.response.data.message);
              window.loginError = Utils.t('login.noPermission');
              window.V._router.push('/login');
            } else {

            }
          })
    }
  },

  beforeRouteLeave(to, from, next) {
    window.removeEventListener('resize', this.resizeListener, true);
    for (var sKey in this.sources) {
      this.sources[sKey].destroy();
    }
    next();
  }
}
</script>

<style lang="scss" scoped>
</style>
